export default __webpack_public_path__ + "static/media/Short Put.adc9be0a.svg";